import dayjs from 'dayjs'

const DateTime = ({ value, timeOnly = false, className }) => {
    const formatStr = timeOnly ? 'HH:mm:ss' : 'DD.MM.YYYY.'

    return <span className={className}>{value ? dayjs(value).format(formatStr) : '--'}</span>
}

export default DateTime
